function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1953 0.265625L4.51172 7.92188L1.80469 5.21484C1.75 5.14193 1.67708 5.10547 1.58594 5.10547C1.49479 5.10547 1.42188 5.14193 1.36719 5.21484L1.03906 5.51562C0.984375 5.58854 0.957031 5.67057 0.957031 5.76172C0.957031 5.85286 0.984375 5.92578 1.03906 5.98047L4.29297 9.23438C4.36589 9.30729 4.4388 9.34375 4.51172 9.34375C4.60286 9.34375 4.6849 9.30729 4.75781 9.23438L12.9609 1.03125C13.0156 0.976562 13.043 0.903646 13.043 0.8125C13.043 0.721354 13.0156 0.639323 12.9609 0.566406L12.6328 0.265625C12.5781 0.192708 12.5052 0.15625 12.4141 0.15625C12.3229 0.15625 12.25 0.192708 12.1953 0.265625Z",
  fill: "currentColor"
});

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.be9f869e.svg";
export { ForwardRef as ReactComponent };